module.exports = require("/Users/martialparfait/Static sites/langtra/.gatsby/gatsby-browser.ts");